import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/breadcrumb/index.js
// module id = 1333
// module chunks = 0